export const API_URL = process.env.REACT_APP_API_URL;
export const PUBLISHER_APP = process.env.REACT_APP_PUBLISHER_APP;
export const APP_DOMAIN = process.env.REACT_APP_APP_DOMAIN;
export const ANIMATED_HOMEPAGE_ICONS =
  process.env.REACT_APP_ANIMATED_HOMEPAGE_ICONS === "true";
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;
